import { CHANGE_ADMIN_VIEW_SECTION } from "./types";

export const changeAdminViewSection = (section) => (dispatch) => {
  dispatch({
    type: CHANGE_ADMIN_VIEW_SECTION,
    payload: section,
  });
};
